// extracted by mini-css-extract-plugin
export var gif = "_kn-0";